import React from 'react';

import { DoubleLeftOutlined, DoubleRightOutlined, LeftOutlined, LoadingOutlined, RightOutlined, VerticalLeftOutlined, VerticalRightOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { t } from 'i18next';

import i18n from 'segments/i18n';
import { MonthEnumEng, MonthEnumRu, WeekEnumEng, WeekEnumRu } from 'segments/utils/constants/common';

interface Props {
  onTimeChange: (arg: Dayjs) => void;
  currentTime: Dayjs | null;
}

const today = dayjs();

function TableSchedules({ onTimeChange, currentTime }: Props) {
  const leftSchedulesButton = [{
    funct: () => onTimeChange(dayjs(currentTime).subtract(1, 'month')),
    icon: <VerticalRightOutlined style={{ fontSize: '12px' }} />
  }, {
    funct: () => onTimeChange(dayjs(currentTime).subtract(1, 'week')),
    icon: <DoubleLeftOutlined style={{ fontSize: '12px' }} />
  }, {
    funct: () => onTimeChange(dayjs(currentTime).subtract(1, 'day')),
    icon: <LeftOutlined style={{ fontSize: '12px' }} />
  }];

  const rightSchedulesButton = [{
    funct: () => onTimeChange(dayjs(currentTime).add(1, 'day')),
    icon: <RightOutlined style={{ fontSize: '12px' }} />
  }, {
    funct: () => onTimeChange(dayjs(currentTime).add(1, 'week')),
    icon: <DoubleRightOutlined style={{ fontSize: '12px' }} />
  }, {
    funct: () => onTimeChange(dayjs(currentTime).add(1, 'month')),
    icon: <VerticalLeftOutlined style={{ fontSize: '12px' }} />
  },];

  const acctualLang = i18n.resolvedLanguage;

  if (currentTime === null) {
    return <LoadingOutlined />;
  }

  const schedulesTittle = acctualLang === 'en'
    ? MonthEnumEng[currentTime?.month()]
    : MonthEnumRu[currentTime?.month()];

  return (
    <Flex
      justify='space-between'
    >
      <div>
        {
          Array.from({ length: 8 }).map((_, weekDay) => {
            const buttonDate = today.add(weekDay, 'day');
            const formatedDate = buttonDate.format('DD-MM');
            return (
              <Button
                key={formatedDate}
                onClick={() => onTimeChange(buttonDate)}
                style={{ fontSize: '12px', padding: '6px 4px', marginRight: '4px', height: '28px' }}
                type={currentTime.format('DD-MM') === formatedDate
                  ? 'primary'
                  : 'default'}
              >
                {
                  acctualLang === 'en'
                    ? WeekEnumEng[buttonDate.day()]
                    : WeekEnumRu[buttonDate.day()]
                }
                {
                  ` ${formatedDate}`
                }
              </Button>
            );
          })
        }
      </div>
      <div>
        {leftSchedulesButton.map((butInfo, index) => (
          <Button
            key={index}
            style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', boxShadow: 'none', }}
            onClick={butInfo.funct}
          >
            {butInfo.icon}
          </Button>
        ))}
        <Typography.Text>
          {`${t('courts.title.schedules')} ${currentTime.date()}-${schedulesTittle}`}
        </Typography.Text>
        {rightSchedulesButton.map((butInfo, index) => (
          <Button
            key={index}
            style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', boxShadow: 'none' }}
            onClick={butInfo.funct}
          >
            {butInfo.icon}
          </Button>
        ))}
      </div>
    </Flex>
  );
}

export default TableSchedules;
